import { getJson } from './client';
import type { PvForecastResponse } from './types';
export const fetchPvForecast = () => getJson<PvForecastResponse>('/api/pv-forecast');
